import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { DireccionesGeograficasFormComponent } from '../../../../ubicaciones/direcciones-geograficas/direcciones-geograficas-form/direcciones-geograficas-form.component';

import { Tecnico, TecnicoFormInput } from '../../entity-tecnicos.model';
import { Persona } from '../../../../persona/entity-personas/entity-personas.model';
import { TelefonosFormComponent } from '../../../../contactos/telefonos/components/telefonos-form.component';
import {
  Telefono,
  TelefonoFormInput
} from '../../../../contactos/telefonos/telefonos.model';
import { DireccionGeografica } from '../../../../ubicaciones/direcciones-geograficas/direcciones-geografica.model';
import { emailValidator } from 'projects/registro-personas-empresas/src/app/shared/validators/email-validators';

@Component({
  selector: 'rpe-tecnico-form',
  templateUrl: './tecnico-form.component.html',
  styleUrls: ['./tecnico-form.component.scss']
})
export class TecnicoFormComponent implements OnInit {
  @Input()
  set formInput(tecnicoFormInput: TecnicoFormInput) {
    if (tecnicoFormInput != null) {
      this._formInput = tecnicoFormInput;
      this.direccionGeograficaFormInput =
        tecnicoFormInput.persona.direccion_geografica;
      this.setInitialValues(tecnicoFormInput.persona);
    }
  }
  get formInput(): TecnicoFormInput {
    return this._formInput;
  }

  @Output() formStatusChanges = new EventEmitter<string>();
  @Output() formValueChanges = new EventEmitter<Tecnico>();

  // Direccion geografica
  @ViewChild(DireccionesGeograficasFormComponent, { static: true })
  direccionGeograficaForm: DireccionesGeograficasFormComponent;

  direccionGeograficaFormInput: DireccionGeografica = null;
  direccionGeografica: DireccionGeografica = null;
  direccionGeograficaValid: boolean = false;

  @ViewChild(TelefonosFormComponent, { static: true })
  telefonosFormComponent: TelefonosFormComponent;
  formInputTelefono: TelefonoFormInput;
  telefonosStatus: string;
  telefonos: Telefono[];

  _formInput: TecnicoFormInput = null;
  tecnicoFormGroup: FormGroup;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {}

  createGroup() {
    this.tecnicoFormGroup = this.fb.group({
      persona_id: [, []],
      tipo_tecnico_id: ['1', []],
      acreditado: ['1', []],
      habilitado: ['1', []],
      direccion_geografica: this.direccionGeograficaForm.createGroup(),
      correo_electronico: this.fb.group({
        direccion: ['', [Validators.required, emailValidator]],
        tipo_correo_id: [1, []]
      }),
      telefonos: [, [Validators.required]]
    });
    return this.tecnicoFormGroup;
  }

  setInitialValues(p: Persona) {
    this.tecnicoFormGroup.patchValue({
      persona_id: p.id,
      correo_electronico: {
        direccion: p.correo_electronico.direccion,
        tipo_correo_id: p.correo_electronico.tipo_correo_id
      },
      telefonos: p.telefonos
    });
    this.formInputTelefono = {
      defaultPais: null,
      preSelectPais: 'uy',
      telefonos: p.telefonos
    };
  }

  // Direccion Geografica
  direccionGeograficaChange(dg: any) {
    this.direccionGeografica = dg;
  }

  direccionGeograficaStatusChange(s: any) {
    this.direccionGeograficaValid = s === 'VALID';
  }

  // Telefonos
  telefonoFormValueChange(telefonos: any) {
    this.telefonos = telefonos;
    this.tecnicoFormGroup.patchValue({
      telefonos: telefonos
    });
  }

  telefonoFormStatusChange(s: any) {
    this.telefonosStatus = s;
    //this.emitFormStatusChanges();
  }
}
